import "./styles/aboutUs.css"
import "./styles/home.css"
import "./styles/nav.css"
import "./styles/ourteam.css"
import "./styles/ourwork.css"
import "./styles/reachout.css"
import "./styles/sitemap.css"

import { RouterProvider, createBrowserRouter } from "react-router-dom"
import Nav from "./components/Nav"
import AboutUs from "./routes/AboutUs"
import HomeWrapper from "./routes/Home"

import DisplayWork from "./routes/DisplayWork"
import OurTeam from "./routes/OurTeam"
import OurWork from "./routes/OurWork"
import Cashout from "./routes/rasking/Cashout"
import RaskingTermsAndConditions from "./routes/rasking/TermsOfService"
import TermsAndConditions from "./routes/unidrive/TermsOfService"
import TermsAndConditionsUnidriver from "./routes/unidrive/TermsOfServiceUnidriver"


function ErrorElement() {
    return (
        <div style={{ width: "100vw", height: "100vh", backgroundColor: '#000' }}>
            <Nav scroll={0} />
            <h1 style={{ margin: 70, textAlign: "center", color: "#FFF", fontSize: 100 }}>OOPS</h1>
            <h2 style={{ textAlign: 'center', color: '#808080' }}>
                Something Went Wrong!!
            </h2>
        </div>
    )
}

const Router = createBrowserRouter([
    {
        path: "/",
        element: <HomeWrapper />, 
        errorElement: ErrorElement
    },
    {
        path: "/about-us",
        element: <AboutUs />, 
        errorElement: ErrorElement
    },
    {
        path: "/our-work",
        element: <OurWork />, 
        errorElement: ErrorElement
    },
    {
        path: "/our-work/:workId",
        element: <DisplayWork />, 
        errorElement: ErrorElement
    },
    {
        path: "/our-team",
        element: <OurTeam />, 
        errorElement: ErrorElement
    },
    {
        path: "/rasking/cashout",
        element: <Cashout />, 
        errorElement: ErrorElement
    },
    {
        path: "/rasking/terms-of-service",
        element: <RaskingTermsAndConditions />, 
        errorElement: ErrorElement
    },
    {
        path: "/unidrive/terms-of-service",
        element: <TermsAndConditions />, 
        errorElement: ErrorElement 
    },
    {
        path: "/unidriver/terms-of-service",
        element: <TermsAndConditionsUnidriver />, 
        errorElement: ErrorElement
    },
    {
        path: "/rasking/terms-of-use",
        element: <RaskingTermsAndConditions />, 
        errorElement: ErrorElement
    },
    {
        path: "/unidrive/terms-of-use",
        element: <TermsAndConditions />, 
        errorElement: ErrorElement
    },
    {
        path: "/unidriver/terms-of-use",
        element: <TermsAndConditionsUnidriver />, 
        errorElement: ErrorElement
    },
])

export default function App() {

    return (
        <>
            <RouterProvider
                router={Router}
            />
            
        </>
    )
}